import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Button, Modal } from "@material-ui/core";
import styles from "./RerunSTT.module.css";
import { useDispatch } from "react-redux";
import PuiTypography from "../../../components/elements/PuiTypography";
import { RerunSTT } from "../../../store/actions/ExVideoActions";
import rerunSTT from "../../../assets/image/rerunSTT.svg";
import { Video } from "../../../common/video/models/Video";
import { t } from "i18next";

interface RerunSTTComponentProps {
    video: Video;
}

export default function RerunSTTComponent({ video }: RerunSTTComponentProps) {
    const dispatch = useDispatch();
    const history = useHistory();

    // STT編集モーダル表示制御
    const [isOpenConfirmModal, ShowConfirmModal] = useState(false);

    const [isShowSubTitle, setShowSubTitle] = useState(false);

    const OpenConfirmModal = () => {
        ShowConfirmModal(true);
    };

    const CloseConfirmModal = () => {
        ShowConfirmModal(false);
    };

    const StartRerunSTT = () => {
        CloseConfirmModal();
        dispatch(RerunSTT(Number(video.id)));
        history.push("/videos");
    };

    return (
        <>
            <div className={styles.rerunSTTIcon} onClick={OpenConfirmModal}>
                <PuiTypography size={14} color={"secondary-font"}>
                    {t("文字起こし")}
                </PuiTypography>
                <img
                    src={rerunSTT}
                    alt="rerunSTT"
                    onMouseEnter={() => setShowSubTitle(true)}
                    onMouseLeave={() => setShowSubTitle(false)}
                />
                {isShowSubTitle && (
                    <div className={styles.subTitle}>
                        <PuiTypography color="black" size={12}>
                            {t("再実行")}
                        </PuiTypography>
                    </div>
                )}
            </div>
            {/* STT再実行確認モーダル */}
            <Modal
                open={isOpenConfirmModal}
                onClose={CloseConfirmModal}
                className={styles.container}
            >
                <div className={styles.confirmModal}>
                    <div className={styles.ul}>
                        <div className={styles.titleText}>
                            <PuiTypography size={18} color={"white"} bold={true}>
                                {t("文字起こしを再実行しますか？")}
                            </PuiTypography>
                        </div>
                        <div style={{ textAlign: "center" }}>
                            <PuiTypography size={14} color={"gray-85"}>
                                {t("今までの編集内容は削除されます")}
                            </PuiTypography>
                        </div>
                        <div className={styles.buttons}>
                            <div className={styles.verifyCancelButton}>
                                <Button
                                    style={{
                                        color: "var(--loading-bg)",
                                        fontSize: "14px",
                                        width: "200px",
                                        fontFamily: "noto-sans-cjk-jp,sans-serif",
                                        border: "solid 2px #5D5D5D",
                                    }}
                                    onClick={CloseConfirmModal}
                                >
                                    {t("いいえ")}
                                </Button>
                            </div>
                            <div className={styles.verifyConfirmButton}>
                                <Button
                                    style={{
                                        color: "white",
                                        fontSize: "14px",
                                        width: "200px",
                                        fontFamily: "noto-sans-cjk-jp,sans-serif",
                                        backgroundColor: "var(--studio-btn-bg)",
                                    }}
                                    onClick={StartRerunSTT}
                                >
                                    {t("はい")}
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
}
